// Key convention [module_name]_[component_name]_[key]
export const strings = {
  'shop_package_image_url_Millionærpakken': 'assets/images/packages/millionaerpakken.svg',
  'shop_package_image_url_Favoritpakken': 'assets/images/packages/favoritpakken.svg',
  'shop_package_image_url_Startpakken': 'assets/images/packages/startpakken.svg',

  'shop_ticket_image_url_Kvartpakken': 'assets/images/shop-purchase/pack-1-8.svg',
  'shop_ticket_image_url_Halvpakken': 'assets/images/shop-purchase/pack-1-4.svg',
  'shop_ticket_image_url_Dobbeltpakken': 'assets/images/shop-purchase/pack-1-1.svg',
  'shop_ticket_image_url_Millionpakken': 'assets/images/shop-purchase/pack-million.svg',
  'shop_ticket_image_url_Tripelpakken': 'assets/images/shop-purchase/pack-tripel.svg',
  'shop_ticket_image_url_Millionærpakken': 'assets/images/packages/millionaerpakken.svg',
  'shop_ticket_image_url_Favoritpakken': 'assets/images/packages/favoritpakken.svg',
  'shop_ticket_image_url_Startpakken': 'assets/images/packages/startpakken.svg',

  'shop_ticket_image_focused_url_Kvartpakken': 'assets/images/shop-purchase/pack-1-8-focused.svg',
  'shop_ticket_image_focused_url_Halvpakken': 'assets/images/shop-purchase/pack-1-4-focused.svg',
  'shop_ticket_image_focused_url_Dobbeltpakken': 'assets/images/shop-purchase/pack-1-1-focused.svg',
  'shop_ticket_image_focused_url_Millionpakken': 'assets/images/shop-purchase/pack-million-focused.svg',
  'shop_ticket_image_focused_url_Tripelpakken': 'assets/images/shop-purchase/pack-tripel-focused.svg',
  'shop_ticket_image_focused_url_Millionærpakken': 'assets/images/packages/millionaerpakken.svg',
  'shop_ticket_image_focused_url_Favoritpakken': 'assets/images/packages/favoritpakken.svg',
  'shop_ticket_image_focused_url_Startpakken': 'assets/images/packages/startpakken.svg',

  'shop_ticket_image_mini_url_Millionærpakken': 'assets/images/packages/millionaerpakken.svg',
  'shop_ticket_image_mini_url_Favoritpakken': 'assets/images/packages/favoritpakken.svg',
  'shop_ticket_image_mini_url_Startpakken': 'assets/images/packages/startpakken.svg',

  'shop_ticket_image_mini_url_3/2': 'assets/images/shop-purchase/single-mega-mini.svg',
  'shop_ticket_image_mini_url_1/1': 'assets/images/shop-purchase/single-1-1-mini.svg',
  'shop_ticket_image_mini_url_1/2': 'assets/images/shop-purchase/single-1-2-mini.svg',
  'shop_ticket_image_mini_url_1/4': 'assets/images/shop-purchase/single-1-4-mini.svg',
  'shop_ticket_image_mini_url_1/8': 'assets/images/shop-purchase/single-1-8-mini.svg',

  'shop_ticket_image_url_3/2': 'assets/images/tickets/focused/focused-megalod.svg',
  'shop_ticket_image_url_1/1': 'assets/images/tickets/focused/focused-hellod.svg',
  'shop_ticket_image_url_1/2': 'assets/images/tickets/focused/focused-halvlod.svg',
  'shop_ticket_image_url_1/4': 'assets/images/tickets/focused/focused-kvartlod.svg',
  'shop_ticket_image_url_1/8': 'assets/images/tickets/focused/focused-ottenedelslod.svg',

  'shop_ticket_image_focused_url_3/2': 'assets/images/tickets/focused/focused-megalod.svg',
  'shop_ticket_image_focused_url_1/1': 'assets/images/tickets/focused/focused-hellod.svg',
  'shop_ticket_image_focused_url_1/2': 'assets/images/tickets/focused/focused-halvlod.svg',
  'shop_ticket_image_focused_url_1/4': 'assets/images/tickets/focused/focused-kvartlod.svg',
  'shop_ticket_image_focused_url_1/8': 'assets/images/tickets/focused/focused-ottenedelslod.svg',

  'shop_ticket_image_small_url_3/2': 'assets/images/tickets/megalod.svg',
  'shop_ticket_image_small_url_1/1': 'assets/images/tickets/hellod.svg',
  'shop_ticket_image_small_url_1/2': 'assets/images/tickets/halvlod.svg',
  'shop_ticket_image_small_url_1/4': 'assets/images/tickets/kvartlod.svg',
  'shop_ticket_image_small_url_1/8': 'assets/images/tickets/ottenedelslod.svg',

  'global_package_normalized_name_10': 'millionærpakken',
  'global_package_normalized_name_11': 'favoritpakken',
  'global_package_normalized_name_12': 'startpakken',

  'global_ticket_normalized_name_0.125': 'ottendedelslod',
  'global_ticket_normalized_name_0.25': 'kvartlod',
  'global_ticket_normalized_name_0.5': 'halvlod',
  'global_ticket_normalized_name_1': 'hellod',
  'global_ticket_normalized_name_1.5': 'megalod',

  'global_package_priority_1': '10',
  'global_package_priority_2': '11',
  'global_package_priority_3': '12',

  'global_package_primary_name_Millionærpakken': 'Millionærpakken',
  'global_package_primary_name_Favoritpakken': 'Favoritpakken',
  'global_package_primary_name_Startpakken': 'Startpakken',

  'global_package_topprize_Millionærpakken': '450000000',
  'global_package_topprize_Favoritpakken': '300000000',
  'global_package_topprize_Startpakken': '150000000',

  'global_package_topprize_text_Millionærpakken': '4,5 mio. kr.',
  'global_package_topprize_text_Favoritpakken': '3 mio. kr.',
  'global_package_topprize_text_Startpakken': '1,5 mio. kr.',

  'global_package_minprize_text_Millionærpakken': '75 kr.',
  'global_package_minprize_text_Favoritpakken': '75 kr.',
  'global_package_minprize_text_Startpakken': '75 kr.',

  'global_package_topprize_text_3/2': '4.5 mio. kr.',
  'global_package_topprize_text_1/1': '3 mio. kr.',
  'global_package_topprize_text_1/2': '1,5 mio. kr.',
  'global_package_topprize_text_1/4': '750.000 kr.',
  'global_package_topprize_text_1/8': '375.000 kr.',

  'global_package_minprize_text_3/2': '900 kr.',
  'global_package_minprize_text_1/1': '600 kr.',
  'global_package_minprize_text_1/2': '300 kr.',
  'global_package_minprize_text_1/4': '150 kr.',
  'global_package_minprize_text_1/8': '75 kr.',

  'global_package_min_prize_Millionærpakken': '7500',
  'global_package_min_prize_Favoritpakken': '7500',
  'global_package_min_prize_Startpakken': '7500',

  'shop_ticket_win_chance_1': '0.41',
  'shop_ticket_win_chance_2': '0.66',
  'shop_ticket_win_chance_3': '0.80',
  'shop_ticket_win_chance_4': '0.88',
  'shop_ticket_win_chance_5': '0.93',
  'shop_ticket_win_chance_6': '0.96',
  'shop_ticket_win_chance_7': '0.97',
  'shop_ticket_win_chance_8': '0.98',
  'shop_ticket_win_chance_9': '0.99',
  'shop_ticket_win_chance_xx': '0.99',
  'shop_package_pointer_image_url': 'assets/icons/pointer.svg',
  'shop_package_pointer_image_url-promoted': 'assets/icons/pointer-animation.svg',
  'global_share_type_name_3/2': 'Megalod',
  'global_share_type_name_1/1': '1/1-lod',
  'global_share_type_name_1/2': '1/2-lod',
  'global_share_type_name_1/4': '1/4-lod',
  'global_share_type_name_1/8': '1/8-lod',
  'global_share_type_min_prize_3/2': '90000',
  'global_share_type_min_prize_1/1': '60000',
  'global_share_type_min_prize_1/2': '30000',
  'global_share_type_min_prize_1/4': '15000',
  'global_share_type_min_prize_1/8': '7500',
  'global_share_type_top_prize_3/2': '450000000',
  'global_share_type_top_prize_1/1': '300000000',
  'global_share_type_top_prize_1/2': '150000000',
  'global_share_type_top_prize_1/4': '75000000',
  'global_share_type_top_prize_1/8': '37500000',
  'global_share_type_top_prize_text_3/2': '4,5 MIO. KR.',
  'global_share_type_top_prize_text_1/1': '3 MIO. KR.',
  'global_share_type_top_prize_text_1/2': '1,5 MIO. KR.',
  'global_share_type_top_prize_text_1/4': '750.000 KR.',
  'global_share_type_top_prize_text_1/8': '375.000 KR.',
  'global_share_type_top_prize_currency_3/2': '4,5 millioner kr.',
  'global_share_type_top_prize_currency_1/1': '3 millioner kr.',
  'global_share_type_top_prize_currency_1/2': '1,5 million kr.',
  'global_share_type_top_prize_currency_1/4': '750.000 kr.',
  'global_share_type_top_prize_currency_1/8': '375.000 kr.',

  'global_ticket_image_url_simple_vert_3/2': 'assets/images/tickets/megalod.svg',
  'global_ticket_image_url_simple_vert_1/1': 'assets/images/tickets/hellod.svg',
  'global_ticket_image_url_simple_vert_1/2': 'assets/images/tickets/halvlod.svg',
  'global_ticket_image_url_simple_vert_1/4': 'assets/images/tickets/kvartlod.svg',
  'global_ticket_image_url_simple_vert_1/8': 'assets/images/tickets/ottenedelslod.svg',

  'global_ticket_image_url_vert_3/2': 'assets/images/tickets/megalod.svg',
  'global_ticket_image_url_vert_1/1': 'assets/images/tickets/hellod.svg',
  'global_ticket_image_url_vert_1/2': 'assets/images/tickets/halvlod.svg',
  'global_ticket_image_url_vert_1/4': 'assets/images/tickets/kvartlod.svg',
  'global_ticket_image_url_vert_1/8': 'assets/images/tickets/ottenedelslod.svg',

  'global_ticket_image_url_hori_3/2': 'assets/images/tickets/hori-svg/lod-1.5-hori.svg',
  'global_ticket_image_url_hori_1/1': 'assets/images/tickets/hori-svg/lod-1-hori.svg',
  'global_ticket_image_url_hori_1/2': 'assets/images/tickets/hori-svg/lod-0.5-hori.svg',
  'global_ticket_image_url_hori_1/4': 'assets/images/tickets/hori-svg/lod-0.25-hori.svg',
  'global_ticket_image_url_hori_1/8': 'assets/images/tickets/hori-svg/lod-0.125-hori.svg',

  'shop_route_parameter_ticket_search_pattern_1': 'starter-med',
  'shop_route_parameter_ticket_search_pattern_2': 'slutter-med',
  'shop_route_parameter_ticket_search_pattern_3': 'indeholder',
  'shop_route_parameter_ticket_search_pattern_4': 'er',

  'shop_ticket_details_content_1/1': 'Klasselotteriets 1/1-lod er lodtypen for dig, der ønsker en høj gevinst.',
  'shop_ticket_details_content_1/2': '1/2-loddet giver dig chancen for at vinde topgevinsten på hele 1.000.000 kr.',
  'shop_ticket_details_content_1/4': 'Klasselotteriets 1/4-lod er for dig, som søger et billigt lod, men stadigvæk vil have chancen for at vinde en stor gevinst.',
  'shop_ticket_details_content_1/8': '1/8-loddet er Klasselotteriets billigste lodtype, hvor din årlige vinderchance er lige så stor, som ved Klasselotteriets øvrige lodder.',
  'shop_ticket_details_content_3/2': 'Megaloddet (3/2-loddet) er Klasselotteriets største lodtype for dig, der ønsker den helt store gevinst.',
  'shop_ticket_details_meta_1/1': 'Spiller du på et 1/1-lod, slipper du for at dele den vundne gevinst med andre, når dit lod udtrækkes - så du kan altså vinde helt op til 2.000.000 kr.',
  'shop_ticket_details_meta_1/2': 'Spiller du på et 1/2-lod, deles den vundne gevinst med én øvrig spiller, når dit lod udtrækkes.',
  'shop_ticket_details_meta_1/4': 'Spiller du på et 1/4-lod, deles den vundne gevinst med tre øvrige spillere, når dit lod udtrækkes.',
  'shop_ticket_details_meta_1/8': 'Med 1/8-loddet skal du dele gevinsten med 7 andre vindere, når dit lod udtrækkes - men du kan stadig vinde helt op til 250.000 kr.',
  'shop_ticket_details_meta_3/2': 'Spiller du på et Megalod, modtager du 3/2 af den vundne gevinst, når dit lod udtrækkes - så du kan altså vinde helt op til 3.000.000 kr.',
  'shop_payment_frequency_1': 'Månedligt',
  'shop_payment_frequency_6': 'Halvårligt',

  'shop_purchase_package_list_chance_Millionærpakken': 'Med Millionærpakken har du chancen for at vinde mellem 75 kr. og 4,5 mio. kr. Gevinsten afhænger af lodtypen. Nedenfor er vist gevinsterne pr. måned ved et Megalod.',
  'shop_purchase_package_list_chance_Favoritpakken': 'Med Favoritpakken har du chancen for at vinde mellem 75 kr. og 3 mio. kr. Gevinsten afhænger af lodtypen. Nedenfor er vist gevinsterne pr. måned ved et 1/1 lod.',
  'shop_purchase_package_list_chance_Startpakken': 'Med Startpakken har du chancen for at vinde mellem 75 kr. og 1,5 mio. kr. Gevinsten afhænger af lodtypen. Nedenfor er vist gevinsterne pr. måned ved et 1/2 lod.',

  'shop_purchase_package_list_chance_3/2': 'Med et Megalod har du chancen for at vinde mellem 900 kr. og 4,5 mio. kr. Nedenfor vises gevinsterne pr. måned for denne lodtype.',
  'shop_purchase_package_list_chance_1/1': 'Med et 1/1-lod har du chancen for at vinde mellem 600 kr. og 3 mio. kr. Nedenfor vises gevinsterne pr. måned for denne lodtype.',
  'shop_purchase_package_list_chance_1/2': 'Med et 1/2-lod har du chancen for at vinde mellem 300 kr. og 1,5 mio. kr. Nedenfor vises gevinsterne pr. måned for denne lodtype.',
  'shop_purchase_package_list_chance_1/4': 'Med et 1/4-lod har du chancen for at vinde mellem 150 kr. og 750.000 kr. Nedenfor vises gevinsterne pr. måned for denne lodtype.',
  'shop_purchase_package_list_chance_1/8': `Med et 1/8-lod har du chancen for at vinde mellem 75 kr. og 375.000 kr. Nedenfor vises gevinsterne pr. måned for denne lodtype.`,
};
